import { Component } from '@angular/core';
import {
  PcapPlayerIndicatorService,
} from '@uigy/modules/settings/modules/pcap-player/components/pcap-player-indicator/pcap-player-indicator.service';
import { LanguageService } from '@uigy/shared/services/language.service';
import { IconsEnum } from '@uigy/generated/icons.enum';

@Component({
  selector: 'app-pcap-player-indicator',
  template: `
    @if (PCAPPlayerFeatureFlag$ | async) {
      <app-ui-header-icon [icon]="IconsEnum.play" [tooltip]="texts.settings.env_config.pcap_player.indicator_title"
                          [isClickable]="false">
      </app-ui-header-icon>
    }
  `,
  styleUrls: ['./pcap-player-indicator.component.scss'],
  standalone: false,
})
export class PcapPlayerIndicatorComponent {
  public readonly texts = this.languageService.texts;
  public PCAPPlayerFeatureFlag$ = this.pcapPlayerIndicator.isPlaying$;
  protected readonly IconsEnum = IconsEnum;

  constructor(private languageService: LanguageService,
              private pcapPlayerIndicator: PcapPlayerIndicatorService) {
  }
}
